module.exports = __webpack_public_path__ + "static/media/56_s3_cam005_small.dfb72004.jpg";